module.exports = __webpack_public_path__ + "img/clerk_weight_tarif_2.3bece47d.png";